/**
 * @generated SignedSource<<03895c0ed41af97ac87b6a1ead4897ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useContentSpaceFragment$data = {
  readonly alias: string | null | undefined;
  readonly id: string | null | undefined;
  readonly key: string | null | undefined;
  readonly name: string | null | undefined;
  readonly " $fragmentType": "useContentSpaceFragment";
};
export type useContentSpaceFragment$key = {
  readonly " $data"?: useContentSpaceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useContentSpaceFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useContentSpaceFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "alias"
    }
  ],
  "type": "Space"
};

(node as any).hash = "5e7d3791ffec068935e152aaea16d3a4";

export default node;
